import React from 'react';
import styles from './ChargerItemLoader.module.css';

const ChargerItemLoader = () => {
    return (
        <div className={`${styles['charger-item']}`}>
            <div className={styles['content']}>
                <div>
                    <div className={styles['content-title']}>
                        <p className="placeholder-glow">
                            <span className="placeholder col-12"></span>
                        </p>
                    </div>
                    <div className={styles['location-name']}>
                        <p className="placeholder-wave">
                            <span className="placeholder col-5"></span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ChargerItemLoader;
